import { TanStackDevtools } from '@tanstack/react-devtools'
import type { QueryClient } from '@tanstack/react-query'
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router'
import { TanStackRouterDevtoolsPanel } from '@tanstack/react-router-devtools'
import { AdminBypassProvider } from '~/app/admin-bypass'
import { AuthedDashboardRedirect } from '~/app/authed-dashboard-redirect'
import TanStackQueryDevtools from '~/app/integrations/tanstack-query/devtools'
import { PlanProvider } from '~/app/plan-context'
import { SessionGate } from '~/app/session-gate'
import { ThemeProvider } from '~/app/theme-provider'
import { NotFound } from '~/shared/ui/not-found'
import { Toaster } from '~/shared/ui/toaster'

interface MyRouterContext {
  queryClient: QueryClient
}

export const Route = createRootRouteWithContext<MyRouterContext>()({
  notFoundComponent: NotFound,
  component: RootComponent,
})

function RootComponent() {
  const isDev = import.meta.env.DEV

  return (
    <ThemeProvider
      attribute="class"
      defaultTheme="system"
      enableSystem
      disableTransitionOnChange
      storageKey="theme"
    >
      <AdminBypassProvider>
        <PlanProvider>
          <SessionGate>
            <AuthedDashboardRedirect>
              <Outlet />
            </AuthedDashboardRedirect>
          </SessionGate>
        </PlanProvider>
      </AdminBypassProvider>
      <Toaster />
      {isDev && (
        <TanStackDevtools
          config={{
            position: 'bottom-right',
          }}
          plugins={[
            {
              name: 'Tanstack Router',
              render: <TanStackRouterDevtoolsPanel />,
            },
            TanStackQueryDevtools,
          ]}
        />
      )}
    </ThemeProvider>
  )
}
